import { config } from '@shakkerai/config';

export const isOversea = config.env === 'aws';

export const isMainland = config.env === 'aliyun';

export const isTest = config.name === 'test';
